/**
 * The TinyCMS swallow (public/brand/tinycms/swallow-mark.svg) drawn inline, so
 * the bird takes the text colour and stays visible on the dark theme. The
 * envelope keeps its brand blue either way.
 */
export function SwallowMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 8 120 88" aria-hidden="true" className={className}>
      <g transform="translate(60 52) rotate(-10) translate(-60 -52)">
        <g fill="currentColor">
          <path d="M55 44 C44 35 26 26 6 27 C22 36 39 48 54 55 Z" />
          <path d="M65 44 C76 35 94 26 114 27 C98 36 81 48 66 55 Z" />
          <ellipse cx="60" cy="50" rx="7.5" ry="14" />
          <circle cx="60" cy="35" r="6.5" />
          <path d="M55.5 61 L46 90 L60 72 L74 90 L64.5 61 Z" />
          <path d="M57.8 29.6 L60 25.8 L62.2 29.6 Z" />
        </g>
        <rect x="51" y="12" width="18" height="13" rx="2" fill="#2F5BEA" />
        <path
          d="M51.6 13 L60 20 L68.4 13"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="1.8"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
